class CompareProducts extends HTMLElement {
  constructor() {
    super();

    this.range = this.querySelector('[data-compare-range]');
    this.addButton = this.querySelector('[data-add-to-cart]');
    this.errorMessage = this.querySelector('[data-error-message]');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.range?.addEventListener('input', this.updateComparePosition.bind(this));
    this.addButton?.addEventListener('click', this.addToCart.bind(this));
    this.updateComparePosition();
  }

  get variantId() {
    return Number(this.dataset.variantId);
  }

  get hasAvailableVariant() {
    return this.dataset.productAvailable === 'true' && Number.isFinite(this.variantId) && this.variantId > 0;
  }

  updateComparePosition() {
    if (!this.range) return;

    const value = Number(this.range.value);
    const clampedValue = Math.min(100, Math.max(0, value));

    this.style.setProperty('--compare-position', `${clampedValue}%`);
  }

  showError(message) {
    if (!this.errorMessage) return;

    this.errorMessage.textContent = message || '';
    this.errorMessage.toggleAttribute('hidden', !message);
  }

  addToCart(event) {
    event.preventDefault();
    if (!this.hasAvailableVariant || !this.addButton || this.addButton.disabled) return;

    this.showError('');
    this.addButton.disabled = true;
    this.addButton.classList.add('loading');
    this.addButton.querySelector('.loading__spinner')?.classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';

    const body = {
      items: [
        {
          id: this.variantId,
          quantity: 1,
        },
      ],
    };

    if (this.cart) {
      body.sections = this.cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      this.cart.setActiveElement(this.addButton);
    }

    config.body = JSON.stringify(body);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'compare-products',
            productVariantId: this.variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.showError(response.description || response.message);
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'compare-products',
          productVariantId: this.variantId,
          cartData: response,
        }).then(() => {
          this.cart.renderContents(response);
        });
      })
      .catch((error) => {
        console.error(error);
        this.showError(window.variantStrings?.cartError || 'Unable to add item to cart.');
      })
      .finally(() => {
        this.addButton.classList.remove('loading');
        this.addButton.querySelector('.loading__spinner')?.classList.add('hidden');
        this.addButton.disabled = !this.hasAvailableVariant;
      });
  }
}

if (!customElements.get('compare-products')) {
  customElements.define('compare-products', CompareProducts);
}
